export class CanaisComunicacaoWhatsAppImagem {
  public phone: string;
  public image: string;
  public guidclientenapis: string;

  constructor() { }
}
